import { orderBy } from 'lodash';

import CoreUtils from '../../common/utils/CoreUtils';

import OptableDataModel from '../optable/OptableDataModel';

export default class OptInDataModel extends OptableDataModel {
  constructor(locale, counterparty, commandDataModel, summaryDataModel) {
    super(locale, counterparty, commandDataModel, 'isOptedIn', true)

    this.summaryDataModel = summaryDataModel;
  }

  processOptableContract(contractDto, contract) {
    super.processOptableContract(contractDto, contract);

    var minimumOptInsPerMonth = parseInt(contractDto.parameters.MinimumOptInsPerMonth);

    contract.minimumOptInCount = minimumOptInsPerMonth;
    contract.remainingOptInCount = minimumOptInsPerMonth;
    contract.currentOptInCount = 0;
    contract.areOptInsRemaining = false;
  }

  updateOverallStatus() {
    super.updateOverallStatus();

    CoreUtils.iterateProperties(this.indexedContracts, (_, contract) => {
      contract.remainingOptInCount = 0;
      contract.currentOptInCount = 0;
      contract.areOptInsRemaining = false;
    });

    CoreUtils.iterateProperties(this.indexedSchedules, (_, schedule) => {
      var contract = this.indexedContracts[schedule.contractCode];
      if (contract === undefined)
        return;

      if (schedule[this.optedDataField]) {
        contract.currentOptInCount += 1;
      }
    });

    if (CoreUtils.isDefinedAndNotNull(this.summaryDataModel)) {
      var contracts = [];
      CoreUtils.iterateProperties(this.indexedContracts, (_, contract) => {
        contract.areOptInsRemaining = contract.currentOptInCount < contract.minimumOptInCount;
        if (contract.areOptInsRemaining) {
          contract.remainingOptInCount = contract.minimumOptInCount - contract.currentOptInCount;
        }

        contracts.push(contract);
      });


      this.summaryDataModel.updateProperties({
        contracts: orderBy(contracts, ['code'], ['asc'])
      });
    }
  }
}